import moment from 'moment';
import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'dashboard';
export default {
    disbursementvsrepaymentmonthly(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/${baseurl}/disbursement-vs-repayment-monthly`;
                const {data}  = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}